import { Button, Card, CardContent, Grid, makeStyles, MenuItem, TextField, Typography } from '@material-ui/core';
import { DateTimePicker } from '@material-ui/pickers';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { dataAxureFetch } from '../../../helpers/fetch';

const useStyles = makeStyles((theme) => ({
    marginRightFix: {
        marginRight: theme.spacing(3),
    },
}));

const HistoricFilters = ({ applyFilters, filters, handleChange }) => {
    const uid = useSelector((state) => state.auth.uid);
    const uptws = useSelector((state) => state.auth.ptws);
    const [points, setPoints] = useState([]);
    const classes = useStyles();

    /**
     * Charge the points
     */
    useEffect(() => {
        getPoints();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Get points from endpoint
     */
    const getPoints = async () => {
        const newPoints = await dataAxureFetch(
            {
                solicitud: 'NomPuntos',
                idCliente: uid,
                ptws:uptws,
            },
            'POST'
        );
        setPoints(newPoints);
    };

    /**
     * To validate for the filters
     * @param {object} filters 
     */
    const validation = (filters) =>{
        let validationDate;
        const momentStart = moment(filters.startDate);
        const momentEnd   = moment(filters.endDate);
        const momentValidationDate =momentStart.clone().add(1,'day')

        if(momentEnd.isAfter(momentValidationDate) || !filters.pointName || momentStart.isAfter(momentEnd)){
            validationDate=true
        }else{
            validationDate=false
        }
        return validationDate
    }

    /**
     * To set message 
     * @param {object} filters 
     */
    const messageError = (filters) =>{
        let validationDate='';
        let color;
        const momentStart = moment(filters.startDate);
        const momentEnd   = moment(filters.endDate);
        const momentValidationDate =momentStart.clone().add(1,'day')

        if(momentEnd.isAfter(momentValidationDate) || momentStart.isAfter(momentEnd)){
            validationDate='Debe seleccionar un rango de 24 horas'
            color = 'error'
        }else if(!filters.pointName){
            validationDate='Seleccione TWS a consultar'
            color = 'error'
        }else{
            validationDate='Consulta activa'
            color = 'primary'
        }

        return {validationDate,color}
    }

    const textValidation = messageError(filters)


    return (
        <Card classes={{ root: classes.marginRightFix }}>
            <CardContent>
                <Typography align={'center'} component="h2" variant="h6" color={textValidation.color}>
                   {textValidation.validationDate}
                </Typography>
                <Grid alignItems="center" container spacing={2}>
                    <Grid item xs>
                        <TextField
                            fullWidth
                            label="TWS"
                            onChange={(event) => handleChange('pointName', event.target.value)}
                            select
                            value={filters.pointName}
                        >
                            {points.map((point) => (
                                <MenuItem key={point.nombre} value={point.nombre}>
                                    {point.nombre}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs>
                        <DateTimePicker
                            format="DD/MM/YYYY hh:mm a"
                            fullWidth
                            label="Fecha inicio"
                            onChange={(date) => {
                                handleChange('startDate', date.format('YYYY-MM-DD HH:mm:ss'));
                            }}
                            value={moment(filters.startDate, 'YYYY-MM-DD HH:mm:ss')}
                            minDate={moment(filters.initialDay, 'YYYY-MM-DD HH:mm:ss')}
                            maxDate={moment(filters.today, 'YYYY-MM-DD HH:mm:ss')}
                        />
                    </Grid>
                    <Grid item xs>
                        <DateTimePicker
                            format="DD/MM/YYYY hh:mm a"
                            fullWidth
                            label="Fecha fin"
                            onChange={(date) => {
                                handleChange('endDate', date.format('YYYY-MM-DD HH:mm:ss'));
                            }}
                            shouldDisableDate={(day) => {
                                const startDate = moment(filters.startDate, 'YYYY-MM-DD');
                                return day.isBefore(startDate, 'days') || day.diff(startDate, 'days') > 30;
                            }}
                            value={moment(filters.endDate, 'YYYY-MM-DD HH:mm:ss')}
                            maxDate={moment(filters.today, 'YYYY-MM-DD HH:mm:ss')}
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            color="primary"
                            disabled={validation(filters)}
                            onClick={applyFilters}
                            variant="contained"
                        >
                            Consultar
                        </Button>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

HistoricFilters.propTypes = {
    applyFilters: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default HistoricFilters;
